import UpdateConfirmationModal from './update-confirmation-modal';

export default UpdateConfirmationModal;
